import './locales/register'
import './page-slots'
import { lazy } from 'react'
import ErrorPage from '@/components/ErrorBoundary/ErrorPage'

import { RouteObject } from 'react-router-dom'
import { paths } from '@/utils/path'

export { SLASettingsRoutes } from './settings-routes'

const List = lazy(() => import('./components/List'))
const Detail = lazy(() => import('./components/Detail'))
const Update = lazy(() => import('./components/Update'))
const CreateAddons = lazy(() => import('./components/CreateAddons'))
const SLAConfig = lazy(() => import('./components/SLAConfig'))
const SLADashboard = lazy(() => import('./components/SLA/Dashboard'))
const SLAServiceReport = lazy(() => import('./components/SLA/ServiceReport'))

const ServiceModule: RouteObject = {
    path: 'services',
    children: [
        {
            path: '',
            element: <List />,
        },
        {
            path: paths.serviceDetail,
            element: <Detail />,
        },
        {
            // Standalone dashboard page (charts/widgets) — separate from
            // tab "Dịch vụ có SLA" which shows the customer-grouped service list
            path: 'sla-dashboard',
            element: <SLADashboard />,
        },
        {
            path: paths.serviceSLAReport,
            element: <SLAServiceReport />,
        },
        {
            path: paths.serviceSLAConfig,
            element: <SLAConfig />,
        },
        {
            path: paths.serviceCreateAddons,
            element: <CreateAddons />,
        },
        {
            path: paths.serviceConfigEdit,
            element: <Update />,
        },
    ],
    errorElement: <ErrorPage status={500} />,
}

export default ServiceModule
